import FieldModel from './FieldModel';
import { DateInput } from '../inputs';
import { isoDateToUTC } from '../../../../juristec-ui/utils/functions/lab';

class DateField extends FieldModel {
  getDefaultState = () => ({
    value: this.default ?? new Date(),
    formatedValue: isoDateToUTC(this.default ?? new Date()) ?? '',
    error: Boolean(this.required),
    errorMsg: this.required ? 'Informe uma data válida' : '',
  });

  genFormatedState = (value) => ({
    value: value ? new Date(value) : null,
    formatedValue: value ? isoDateToUTC(new Date(value)) : '',
    error: false,
    errorMsg: '',
  });

  fieldComponent = (tempState, state, handle) => {
    const prepHandle = (value) => handle({
      [this.kWord]: {
        value,
        formatedValue: value ? isoDateToUTC(value) : '',
        error: false,
        errorMsg: '',
      },
    });
    return (
      <DateInput
        label={this.label}
        state={tempState?.[this.kWord] ?? state[this.kWord] ?? this.getDefaultState()}
        handle={prepHandle}
      />
    );
  };
}

export default DateField;
